module.exports = __webpack_public_path__ + "img/checkLogoNew.8740c800.png";